/**
 * UI Slice - Handles UI-related state changes
 *
 * Actions handled:
 * - SELECT_CARD
 * - DESELECT_CARD
 * - CLEAR_SELECTION
 * - SET_SELECTED_CARDS
 * - SHOW_ROUND_END
 * - SHOW_PLAYER_FINISHED
 * - SET_FINISHED_PLAYER_SPLASH
 * - SET_LAST_ACTION
 */

// Initial UI state (extracted from initialGameState)
export const initialUiState = {
  selectedCards: [],
  showRoundEnd: false,
  showPlayerFinished: false,
  finishedPlayerData: null,
  finishedPlayerSplash: null,
  lastAction: null,
  lastActionPlayer: null,
  lastPlaySize: 0,
};

/**
 * UI action types
 */
export const UI_ACTIONS = [
  'SELECT_CARD',
  'DESELECT_CARD',
  'CLEAR_SELECTION',
  'SET_SELECTED_CARDS',
  'SHOW_ROUND_END',
  'SHOW_PLAYER_FINISHED',
  'SET_FINISHED_PLAYER_SPLASH',
  'SET_LAST_ACTION',
];

/**
 * Check if action is handled by this slice
 */
export function isUiAction(actionType) {
  return UI_ACTIONS.includes(actionType);
}

/**
 * UI reducer slice
 */
export function uiReducer(state, action) {
  switch (action.type) {
    case 'SELECT_CARD':
      return handleSelectCard(state, action.payload);

    case 'DESELECT_CARD':
      return handleDeselectCard(state, action.payload);

    case 'CLEAR_SELECTION':
      return {
        ...state,
        selectedCards: [],
      };

    case 'SET_SELECTED_CARDS':
      return {
        ...state,
        selectedCards: action.payload,
      };

    case 'SHOW_ROUND_END':
      return {
        ...state,
        showRoundEnd: action.payload,
      };

    case 'SHOW_PLAYER_FINISHED':
      return {
        ...state,
        showPlayerFinished: action.payload.show,
        finishedPlayerData: action.payload.data,
      };

    case 'SET_FINISHED_PLAYER_SPLASH':
      return {
        ...state,
        finishedPlayerSplash: action.payload,
      };

    case 'SET_LAST_ACTION':
      return {
        ...state,
        lastAction: action.payload.action,
        lastActionPlayer: action.payload.player,
        lastPlaySize: action.payload.playSize ?? state.lastPlaySize,
      };

    default:
      return state;
  }
}

// === Helper Functions ===

/**
 * Add card to selection
 */
function handleSelectCard(state, card) {
  const isAlreadySelected = state.selectedCards.some(
    c => c.rank === card.rank && c.suit === card.suit
  );

  if (isAlreadySelected) {
    return state;
  }

  return {
    ...state,
    selectedCards: [...state.selectedCards, card],
  };
}

/**
 * Remove card from selection
 */
function handleDeselectCard(state, card) {
  return {
    ...state,
    selectedCards: state.selectedCards.filter(
      c => !(c.rank === card.rank && c.suit === card.suit)
    ),
  };
}

export default uiReducer;
